import { render, staticRenderFns } from "./cpu-chip.vue?vue&type=template&id=fc73599c&"
import script from "./cpu-chip.vue?vue&type=script&lang=js&"
export * from "./cpu-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports